import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Tag } from 'primereact/tag'
import { Image } from 'primereact/image';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { OverlayPanel } from 'primereact/overlaypanel';
import FilterControlIcon from '../../assets/images/icons/filterControl.svg';
import { Checkbox } from "primereact/checkbox";

export default function ColumnsFilter(props) {
   const filterControlOverlay = useRef(null);
   const { columnsList, applyColumns, index } = props;

   const [filters, setFilters] = useState({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      'name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      representative: { value: null, matchMode: FilterMatchMode.IN },
      status: { value: null, matchMode: FilterMatchMode.EQUALS },
      verified: { value: null, matchMode: FilterMatchMode.EQUALS }
   });

   const defaultSelectedColumns = columnsList.slice(0, index);
   const [selectedColumnsVisibility, setColumnsVisibility] = useState(defaultSelectedColumns);

   const onCheckBoxChange = (e) => {

      const { checked, value } = e;
      let _selectedColumnsVisibility = [...selectedColumnsVisibility];


      if (!checked && defaultSelectedColumns.some(item => item.key === value.key)) {
         return;
      }
      else
         if (checked) {
            _selectedColumnsVisibility.push(value);
         } else {
            _selectedColumnsVisibility = _selectedColumnsVisibility.filter(columns => columns.key !== value.key);
         }
      setColumnsVisibility(_selectedColumnsVisibility);
   };


   const applyFiltersOnColumns = () => {
      filterControlOverlay.current.hide();
      //setTableColumns(selectedColumnsVisibility);
      applyColumns(selectedColumnsVisibility);
   };

   const handleCancelClick = () => {
      filterControlOverlay.current.hide();
      setColumnsVisibility(props.tableColumns)
   }


   return (
      <div>
         <Button type="button" className='filtercontrol-btn' onClick={(e) => filterControlOverlay.current.toggle(e)}><Image src={FilterControlIcon} alt="Image" width="24" /></Button>
         <OverlayPanel ref={filterControlOverlay} className='filtercontrol-panel'>
            <Box>
               <Box className='panel-header'>
                  <Typography level="title-sm" className='fs-2'>Column Visibility</Typography>
               </Box>
               <Box className='panel-body'>
                  {columnsList.map((column) => {
                     return (
                        <div key={column.key} className="list-item flex align-items-center">
                           <Checkbox name="column" value={column} onChange={onCheckBoxChange} checked={selectedColumnsVisibility.some((item) => item.key === column.key)} />
                           <label htmlFor={column.key} className="ml-2">
                              {column.name}
                           </label>
                        </div>
                     );
                  })}
               </Box>
               <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={1} className="panel-footer form-footer">
                  <Button type="button" className="button-style-2" label="Cancel" size="small" onClick={handleCancelClick}></Button>
                  <Button type="button" className="button-style-1" label="Apply" size="small" onClick={applyFiltersOnColumns}></Button>
               </Box>
            </Box>
         </OverlayPanel>
      </div>
   )
}

